// extracted by mini-css-extract-plugin
module.exports = {"scdmq5l":"scdmq5l","csktwd1":"csktwd1"};